export const totalService = {
    UTILITY: [
        {code: "MEA", name: "การไฟฟ้านครหลวง", image: "MEA.png", type:"DEFAULT"},
        {code: "PEA", name: "การไฟฟ้าส่วนภูมิภาค", image: "PEA.png", type:"DEFAULT"},
        {code: "MWA", name: "การประปานครหลวง", image: "MWA.png", type:"DEFAULT"},
        {code: "PWA", name: "การประปาส่วนภูมิภาค", image: "PWA.png", type:"DEFAULT"}
    ]
};